let lastScrollTop = 0;
let isThrottled;
const mobileMenuTarget = document.querySelector('header > .row');
const minScrollDistance = 10;

function manageHideRevealMenu() {
  const currentScroll = window.scrollY || document.documentElement.scrollTop;

  if (!mobileMenuTarget) {
    return;
  }

  if (currentScroll <= window.innerHeight) {
    mobileMenuTarget.classList.remove('hide-mobile-menu');
  } else {
    if (document.getElementById('sitecontent').classList.contains('nav-open') === false && (currentScroll > lastScrollTop && currentScroll - lastScrollTop > minScrollDistance)) {
      mobileMenuTarget.classList.add('hide-mobile-menu');
    } else if (currentScroll < lastScrollTop) {
      mobileMenuTarget.classList.remove('hide-mobile-menu');
    }
  }
  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
}

function manageStickyHeader() {
  const topDistance = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
  const header = document.querySelector('.header-main');

  if (header) {
    if (topDistance > header.offsetTop) {
      header.classList.add('header-main--sticky');
    } else {
      header.classList.remove('header-main--sticky');
    }
  }
}

function manageMobileDonateButton() {
  const buttonDonate = document.querySelector('.nav-donate-mobile');
  const hiddenClass = 'nav-donate--hidden-mobile';

  if (!buttonDonate) {
    return;
  }

  if (window.scrollY >= window.innerHeight) {
    buttonDonate.classList.remove(hiddenClass);
  } else {
    buttonDonate.classList.add(hiddenClass);
  }
}

function onScrollActions() {
  if (isThrottled) return;

  isThrottled = true;

  setTimeout(function() {
    isThrottled = false;
    manageStickyHeader();
    manageMobileDonateButton();
    manageHideRevealMenu();
  }, 33);
}

export default () => {
  manageStickyHeader();
  manageMobileDonateButton();
  manageHideRevealMenu();

  window.onscroll = onScrollActions;
};
